export default __webpack_public_path__ + "static/rounded-0f9d75d61d4ea5c5edde9655f1545e47.png";